<template>  
    <div class="text-sm">
        <ul>
            <li class="mb-4"><span class="inline-block w-24 font-black lg:w-40">Nombre:</span><span> {{ data.name }} {{ data.surnames }}</span></li>
            <li class="mb-4"><span class="inline-block w-24 font-black lg:w-40">Experiencia:</span><span> +{{ data.experience }} años</span></li>
            <li class="mb-4"><span class="inline-block w-24 font-black lg:w-40">Trabajo:</span><span> {{ data.job }}</span></li>
            <li class="mb-4"><span class="inline-block w-24 font-black lg:w-40">Dirección:</span><span> {{ data.address }}</span></li>
            <li class="mb-4"><span class="inline-block w-24 font-black lg:w-40">Disponibilidad:</span><span> {{ data.availability }}</span></li>
        </ul>
        <ul>
            <li class="mb-4">
              <span class="inline-block w-24 font-black lg:w-40">Idiomas:</span>
              <span v-for="(language, index) in languages" :key="index"> {{ language.name }} {{ language.competence}}<span v-if="index !== languages.length - 1">,</span></span>
            </li>
            <li class="mb-4">
              <span class="inline-block w-24 font-black lg:w-40">Intereses:</span>
              <span v-for="(interest, index) in interests" :key="index"> {{ interest }}<span v-if="index !== interests.length - 1">,</span></span>
            </li>
        </ul>
    </div>
</template>

<script>
import data from '../data/profile'
import interests from '../data/interests'
import languages from '../data/languages'

export default {
  name: "PersonalData",
  data() {
    return {
      data: data,
      interests: interests,
      languages: languages
    }
  }
};
</script>
